import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { Injectable } from '@angular/core';
import { globalStore } from '../../../../modules/shared/shared.global-service';
import { selectWorkRecordDate } from '../../../../modules/content/store/service/service.selectors';

@Injectable()
export class WorkContinuousRecordStore extends ComponentStoreV2Factory {

    public workDate = globalStore!.selectSignal(selectWorkRecordDate);
}
